import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAdmin } from "../../context/AdminContext";
import { toast } from "sonner";
import { inputCls } from "../../components/admin/Fields";

const AdminLogin = () => {
  const { isAuthed, login } = useAdmin();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (isAuthed) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(password);
      toast.success("Welcome back!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Incorrect password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-blush/20 flex items-center justify-center mx-auto mb-5">
            <Lock size={22} className="text-blush" />
          </div>
          <h1 className="font-serif text-4xl text-white">George & Amy</h1>
          <p className="text-offwhite/60 mt-2 text-sm uppercase tracking-[0.2em]">Content Manager</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-xl p-8 shadow-2xl space-y-5">
          <div>
            <label className="block uppercase tracking-[0.14em] text-[11px] font-bold text-navy/60 mb-2">Shared Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={inputCls}
              placeholder="Enter password"
              autoFocus
              data-testid="admin-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-full bg-navy text-white uppercase tracking-[0.18em] text-sm py-3.5 hover:bg-dusty transition-colors disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {busy ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
